import { render, staticRenderFns } from "./CommercialForm.vue?vue&type=template&id=2a693770&"
import script from "./CommercialForm.vue?vue&type=script&lang=js&"
export * from "./CommercialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports